import DraftNumberInput from "../../../inputs/DraftNumberInput";
import ProductWidgetContainer from "./ProductWidgetContainer";
import styled from "styled-components/macro";
import { Checkbox, FormControlLabel, Typography } from "@material-ui/core";
import { getDistribution } from "../../../../adapters/distributionHelper";

const FlexSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const StudioWebProductWidget = ({
  product,
  onRemove,
  onProductChange,
  editable,
  baselineProfile,
  deploymentType,
}: any) => {
  const handleProfileChange = (newProfile: string) => {
    const productCopy = { ...product, profile: newProfile };
    onProductChange(productCopy);
  };

  const isRke2 = getDistribution(deploymentType) === "rke2";
  // Absent property means NFS — the recommended default (and the semantic for
  // share-URLs that predate the option).
  const useNfs = product.properties?.useNfsFileStore !== false;

  // Deliberately NOT gated on `editable`: the choice only exists on the
  // Default (eval) profile, where scaling inputs are read-only but this
  // storage decision is still the user's to make.
  const handleNfsToggle = () => {
    const productCopy = {
      ...product,
      properties: { ...product.properties, useNfsFileStore: !useNfs },
    };
    onProductChange(productCopy);
  };

  return (
    <ProductWidgetContainer
      onRemove={onRemove}
      title={product.name}
      productKey={product.key}
      canBeRemoved={product.canBeRemoved}
      productProfile={product.profile}
      deploymentType={deploymentType}
      onProfileChange={handleProfileChange}
    >
      <FlexSection>
        <DraftNumberInput
          label="Number of Concurrent Workflows"
          product={product}
          field="concurrentWorkflows"
          baselineProfile={baselineProfile}
          editable={editable}
          onProductChange={onProductChange}
        />
      </FlexSection>
      {isRke2 && baselineProfile === "default" && (
        <FormControlLabel
          control={
            <Checkbox
              checked={useNfs}
              onChange={handleNfsToggle}
              name="useNfsFileStore"
            />
          }
          label="Use NFS file store (recommended)"
        />
      )}
      {isRke2 && baselineProfile !== "default" && (
        <Typography variant="body2" color="textSecondary">
          Studio Web requires an NFS-based RWX file store on this profile.
        </Typography>
      )}
    </ProductWidgetContainer>
  );
};

export default StudioWebProductWidget;
